export default __webpack_public_path__ + "static/media/close.064b9599.png";